import { useLayoutEffect, useState } from 'react'

export default function useWindowWidth() {
  const [width, setWidth] = useState(0)

  useLayoutEffect(() => {
    function updateWidth() {
      try {
        setWidth(window.innerWidth)
      } catch {
        // noop for non-browser environments
      }
    }
    window.addEventListener?.('resize', updateWidth)
    updateWidth()
    return () => window.removeEventListener?.('resize', updateWidth)
  }, [])

  return width
}
